import { Text } from '@mantine/core';
import styled from 'styled-components';
import { Flex } from '..';
import { ReactComponent as ShareDiagramComponent } from '../../assets/images/share-diagram.svg';
import { ReactComponent as AlertYellowGradientComponent } from '../../assets/icons/alert-yellow-gradient.svg';
import { fontSize, getColor } from '../../styles/mixins';

export const ModalTitle = styled(Text)`
  ${fontSize(24)};
  color: ${getColor('gray', 700)};
  font-weight: 500;
`;

export const ShareDiagramIcon = styled(ShareDiagramComponent)`
  width: 150px;
`;

export const LinkContainer = styled(Flex)`
  padding: 12px;
  border: 2px solid ${getColor('gray', 200)};
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  color: ${getColor('gray', 400)};
  transition: all 0.2s ease-in-out;
  &:hover {
    border: 2px solid ${getColor('purple', 500)};
    color: ${getColor('purple', 700)};
  }
`;

export const LinkText = styled(Text)`
  ${fontSize(14)};
  line-height: 1;
  color: ${getColor('gray', 400)};
  font-weight: 500;
  margin-right: 12px;
  overflow: hidden;
  white-space: nowrap;
`;

export const SwitchLabel = styled(Text)`
  ${fontSize(20)};
  color: ${getColor('gray', 700)};
  font-weight: 600;
`;

export const AlertContainer = styled(Flex)`
  padding: 10px 8px 8px 8px;
  border-radius: 6px;
  background-color: ${getColor('yellow', 200)};
  align-items: center;
`;

export const AlertIcon = styled(AlertYellowGradientComponent)`
  width: 28px;
`;

export const AlertText = styled(Text)`
  ${fontSize(14)};
  color: ${getColor('yellow', 800)};
  font-weight: 500;
`;
